import { render } from "./FeedbackPage.vue?vue&type=template&id=d7c87018"
import script from "./FeedbackPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__